import { Box, IBoxComponentProps, IconButton, ILabelComponentProps, Label, Text } from '@moosend/mooskin';
import * as React from 'react';
import { Link } from 'react-router-dom';

export const StatsBox: React.FC<IBoxComponentProps> = (props) => {
	return (
		<Box
			border="solid 1px #e7e7e7"
			borderRadius={3}
			p={15}
			bgColor="backgroundColors.white"
			d="flex"
			direction="column"
			justify="space-between"
			// overflow="hidden"
			position="relative"
			flex={1}
			// maxW={300}
			minH={150}
			{...props}
		>
			{props.children}
		</Box>
	);
};

export const StatsBoxTitle: React.FC<ILabelComponentProps> = (props) => {
	return (
		<Label fontSize={29} fontWeight="bold" {...props}>
			{props.children}
		</Label>
	);
};

export const StatsBoxAnchor: React.FC<ILabelComponentProps & { redirectUrl?: string }> = (props) => {
	const label = (
		<Label
			cursor={props.redirectUrl ? 'pointer' : 'unset'}
			textDecoration="none"
			d="flex"
			align="center"
			color="#293346"
			fontSize={12}
			fontWeight="bold"
			{...props}
		>
			{props.children}
			<IconButton
				ml={5}
				fontSize={13}
				children="chevron_right"
				fontWeight="bold"
				// color="#293346"
				cursor={props.redirectUrl ? 'pointer' : 'unset'}
			/>
		</Label>
	);

	if (!props.redirectUrl) {
		return label;
	}

	return <Link to={props.redirectUrl}>{label}</Link>;
};

export const StatsBoxText: React.FC<IBoxComponentProps> = (props) => {
	return (
		<Text fontSize={14} {...props}>
			{props.children}
		</Text>
	);
};

export const StatsBoxBottom: React.FC<IBoxComponentProps> = (props) => {
	return <Box h={4} bgColor="backgroundColors.primary2" position="absolute" left={0} right={0} bottom={0} {...props} />;
};
